<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 封禁管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input
            v-model="listQuery.content"
            placeholder="手机/账号"
            style="width: 200px; margin-right: 10px"
          ></el-input>
          <el-select
            v-model="listQuery.block_type"
            placeholder="封禁类型"
            style="width: 200px"
          >
            <el-option label="手机号封禁" :value="1"> </el-option>
            <el-option label="账号封禁" :value="2"> </el-option>
          </el-select>
          <el-button
            class="filter-item"
            style="margin-left: 10px"
            type="primary"
            @click="reset"
            >重置</el-button
          >
          <el-button
            class="filter-item"
            style="margin-left: 10px"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
            >搜索</el-button
          >
          <el-button
            class="filter-item"
            style="margin-left: 10px"
            type="success"
            @click="handleCreate"
            >添加</el-button
          >
        </div>

        <el-table
          border
          min-height="200"
          max-height="1000"
          v-loading="listLoading"
          :data="tableData"
          :default-sort="{ prop: 'created_at', order: 'descending' }"
          style="width: 100%"
          @sort-change="sortChange"
        >
          <el-table-column prop="content" label="手机号/账号" />
          <el-table-column prop="block_type" label="封禁类型">
            <template slot-scope="scope"
              >{{ scope.row.block_type === 1 ? "手机号封禁" : "账号封禁" }}
            </template>
          </el-table-column>
          <el-table-column prop="deal_user" label="处理人" />
          <el-table-column
            prop="created_at"
            label="提交时间"
            sortable
          ></el-table-column>
          <el-table-column
            label="操作"
            width="260"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top"
                width="160"
                v-model="scope.row.deleteVisible"
              >
                <p>确定删除吗?</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="scope.row.deleteVisible = false"
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleDelete(scope.row)"
                    >确定</el-button
                  >
                </div>
                <el-button
                  slot="reference"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  >删除</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleList"
        />
        <el-dialog
          title="新增封禁"
          width="600px"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          @close="closeDialog"
        >
          <el-form :model="formData" style="margin-left: 50px">
            <el-form-item label="账号" :label-width="formLabelWidth">
              <el-col :span="19">
                <el-input v-model="formData.content"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="封禁类型" :label-width="formLabelWidth">
              <el-col :span="19">
                <el-select
                  v-model="formData.block_type"
                  placeholder="封禁类型"
                  style="width: 100%"
                >
                  <el-option label="手机号封禁" :value="1"> </el-option>
                  <el-option label="账号封禁" :value="2"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeAdd">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  handleListApi,
  handleCreateStoreApi,
  handleDeleteApi,
} from "@/api/work_prohibition.js";
import Pagination from "@/components/pagination/index";
export default {
  components: { Pagination },
  name: "prohibition",
  data() {
    return {
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {},
      // 添加数据的缓存。
      addData: {},
      addCheck: 0,

      // 表单
      dialogFormVisible: false,
      formData: {},
      formLabelWidth: "120px",
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    reset() {
      this.listQuery = {};
      this.handleList();
    },
    sortChange(e) {
      switch(e.order) {
        case 'ascending':
          this.listQuery.sort = e.prop;
          this.listQuery.order = 'asc';  
          break;
        case 'descending':
          this.listQuery.sort = e.prop;
          this.listQuery.order = 'desc'; 
          break;
        default:
          if (this.listQuery.sort) delete this.listQuery.sort
          if (this.listQuery.order) delete this.listQuery.order
      }
      this.handleList()
    },
    handleList() {
      this.listLoading = true;
      handleListApi(this.listQuery)
        .then((response) => {
          const data = response.data.data;
          this.tableData = data.data;
          this.total = data.total;
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    handleCreate() {
      this.handleResetForm();
      if (this.addCheck == 1) {
        this.formData = JSON.parse(JSON.stringify(this.addData));
      }

      this.dialogFormVisible = true;
    },
    closeDialog() {
      if (this.addCheck == 0 || this.addCheck == 1) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
    handleDelete(row) {
      handleDeleteApi(row.id)
        .then((response) => {
          this.$message.success("操作成功");
          row.deleteVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleResetForm() {
      this.formData = {};
      this.dialogFormVisible = false;
    },
    removeAdd() {
      this.dialogFormVisible = false;
    },
    handleCreateUpdateStore() {
      handleCreateStoreApi(this.formData)
        .then((response) => {
          this.$message.success("操作成功");
          this.addCheck = 2;
          this.dialogFormVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.handleList(this.listQuery);
    },
  },
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
